export default __webpack_public_path__ + "static/media/nhl-bg.6dcb1e26.jpg";